module.exports = __webpack_public_path__ + "src/assets/img/door_left_back.be37fcf6.svg";